import { inject } from '@angular/core'
import { CanMatchFn, Router } from '@angular/router'
import { AuthService } from '@services/auth.service'

export const authGuard: CanMatchFn = (route, segments) => {
  const isLoggedIn = inject(AuthService).isLoggedIn$
  if (!isLoggedIn()) {
    navigateAuth(segments.map((s) => s.path).join('/'))
  }
  return isLoggedIn()
}

export const navigateAuth = (redirectUrl: string) => {
  const router = inject(Router)
  if (!redirectUrl) {
    return
  }
  router.navigate(['/auth', 'login'], {
    queryParams: { redirect: redirectUrl },
  })
}

export const noAuthGuard: CanMatchFn = (_, __) => {
  const isLoggedIn = inject(AuthService).isLoggedIn$

  return !isLoggedIn()
}
